<form class="grid grid-cols-1 md:grid-cols-[1fr_2fr_1fr_auto] gap-2 items-end" (ngSubmit)="go()">
  <label class="block">
    <span class="ceo-label">Write password</span>
    <input type="password" class="ceo-input" name="password" autocomplete="off" [(ngModel)]="v2.password" [disabled]="busy" />
  </label>
  <label class="block">
    <span class="ceo-label">Reason <span class="font-normal text-slate-400">(audit log)</span></span>
    <input type="text" class="ceo-input" name="reason" autocomplete="off" placeholder="why, in a sentence" [(ngModel)]="reason" [disabled]="busy" />
  </label>
  <label class="block" *ngIf="confirmText; else noConfirm">
    <span class="ceo-label">Type <span class="font-mono text-slate-800">{{ confirmText }}</span></span>
    <input type="text" class="ceo-input font-mono" name="confirm" autocomplete="off" [(ngModel)]="confirm" [disabled]="busy" />
  </label>
  <ng-template #noConfirm><span></span></ng-template>
  <button type="submit"
          class="h-9 px-3 text-xs font-semibold text-white rounded-lg transition-colors disabled:opacity-50 whitespace-nowrap"
          [ngClass]="danger ? 'bg-red-600 hover:bg-red-700' : 'bg-blue-600 hover:bg-blue-700'"
          [disabled]="!ready">
    <i class="fa-solid" [ngClass]="busy ? 'fa-spinner fa-spin' : 'fa-check'"></i> {{ label }}
  </button>
</form>
<p *ngIf="error" class="mt-2 text-xs text-red-600"><i class="fa-solid fa-circle-exclamation mr-1"></i>{{ error }}</p>
<p *ngIf="done" class="mt-2 text-xs text-emerald-700"><i class="fa-solid fa-circle-check mr-1"></i>Done — recorded in the audit log.</p>
